import { TermsActionTypes } from './types';
import { createAsyncAction, createAsyncMapAction } from '~lib/shared/redux/actions';
export const recordAgreement = createAsyncMapAction(TermsActionTypes.RECORD_AGREEMENT, p => [p.userId, p.document].join('@'));
export const latestDocuments = createAsyncAction(TermsActionTypes.LATEST_DOCUMENTS);
export const userStatus = createAsyncMapAction(TermsActionTypes.USER_STATUS, p => p.userId);
